import {option, Option} from "ts-option";
import {CreateUpdateFinanceProductApiDto, FinanceProductApiDto} from "../../api/model/rest";

export default class FinanceProduct {
	constructor(public readonly id: string,
		public readonly label: string,
		public readonly description: Option<string>,
		public readonly provider: string,
		public readonly annualPercentageRate: number,
		public readonly fee: Option<number>,
		public readonly disabled: boolean
	) {}

	static fromJson(json: FinanceProductApiDto) {
		return new FinanceProduct(json.id, json.label, option(json.description), json.provider, json.annualPercentageRate,
			option(json.fee), json.disabled)
	}

	toJson(): CreateUpdateFinanceProductApiDto {
		return {
			label: this.label,
			description: this.description.orNull,
			provider: this.provider,
			annualPercentageRate: this.annualPercentageRate,
			fee: this.fee.orNull,
			disabled: this.disabled
		}
	}
}